import { all, takeEvery, put } from 'redux-saga/effects'
import actions from './actions'

export function* setloader() {
  yield put({
    type: 'customSpinner/SET_STATE',
    payload: {
      apiloading: true,
    },
  })
}

export function* removeLoader() {
  yield put({
    type: 'customSpinner/SET_STATE',
    payload: {
      apiloading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.setloader, setloader),
    takeEvery(actions.removeLoader, removeLoader),
  ])
}
